import { render, staticRenderFns } from "./ModalInvoiceTemplateRemark.vue?vue&type=template&id=0279a319&"
import script from "./ModalInvoiceTemplateRemark.vue?vue&type=script&lang=js&"
export * from "./ModalInvoiceTemplateRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports